// News.js - Page for news articles
import React from 'react';
import Navbar from './Navbar';
import './News.css';

const News = () => {
  // Mock data for news
  const newsArticles = [
    { title: 'Khai giảng lớp giáo lý mới', date: '01/08/2025', content: 'Năm học mới sẽ khai giảng vào ngày 07/08/2025.' },
    // { title: 'Hoạt động bác ái thiếu nhi', date: '15/07/2025', content: 'Các em tham gia giúp đỡ cộng đồng.' },
    // { title: 'Lễ bổn mạng trường', date: '08/12/2024', content: 'Kỷ niệm Đức Mẹ Vô Nhiễm.' },
  ];

  return (
    <div>
      <Navbar />
      <div className="news-container">
        <h2>Tin tức mới nhất</h2>
        {newsArticles.map((article, index) => (
          <div key={index} className="news-item">
            <h3>{article.title}</h3>
            <p>Ngày: {article.date}</p>
            <p>{article.content}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default News;